import React from "react";
import { transformBrandNames } from "../../../../../../utils";
import { RenderWhen } from "../../../../../../components";
import { TiCardGeneralData } from "../../../../@types";
import TiCardAdditionalInformationLayout, {
  TiCardAdditionalInformationLayoutProps
} from "./TiCardAdditionalInformationLayout";

interface Props extends TiCardAdditionalInformationLayoutProps {
  data: TiCardGeneralData;
}

const TiCardThreatNameAdditionalInformation = ({
  data,
  closeDetails,
  seeRelatedSamplesRoute
}: Props) => (
  <TiCardAdditionalInformationLayout
    closeDetails={closeDetails}
    seeRelatedSamplesRoute={seeRelatedSamplesRoute}
  >
    <p
      style={{ marginBottom: 0 }}
      data-testid="ticard_threat_name_malware_description"
    >
      <b>
        {data.malware_type?.toLowerCase() === "exploit"
          ? "Vulnerability Description: "
          : "Threat Description: "}
      </b>

      {transformBrandNames(
        data.malware_family_description?.length
          ? data.malware_family_description
          : data.malware_type_description
      )}
    </p>
    <div
      className={"ticard-content__additional_information__references"}
      data-testid="ticard_threat_name_references"
    >
      <b>References:</b>
      <div className={"references_list"}>
        <RenderWhen
          condition={!!data?.news_references?.length}
          fallback={"No references found."}
        >
          {data?.news_references?.map((reference, idx) => (
            <a
              key={`news_${reference}`}
              className={"overflow-ellipsis"}
              href={reference}
              target="_blank"
              rel="noreferrer"
              data-testid={`ticard_threat_name_references_link_item_${idx}`}
            >
              {reference}
            </a>
          ))}
        </RenderWhen>
      </div>
    </div>
  </TiCardAdditionalInformationLayout>
);

export default TiCardThreatNameAdditionalInformation;
